import { injectGlobal } from 'styled-components'

/* eslint-disable */
injectGlobal`
  @import url('https://fonts.googleapis.com/css?family=Raleway');

  body, .smooth-container {
    scroll-behavior: smooth
  }

  body {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    font-family: 'Raleway', sans-serif;
  }
`



// WEBPACK FOOTER //
// ./src/GlobalThemes.js